import type { LottieRefCurrentProps } from "lottie-react";

import * as React from "react";

import { cn } from "@replohq/lattice/utils/cn";
import loadingAnimation from "@v2/components/reploader.json";
import { useTheme } from "@v2/hooks/useTheme";
import Lottie from "lottie-react";

type Props = {
  visible?: boolean;
};

export function FullScreenLoader({ visible = true }: Props) {
  const lottieRef = React.useRef<LottieRefCurrentProps>(null);
  const { effectiveMode, palette } = useTheme();

  // eslint-disable-next-line replo/no-use-effect -- Legacy effect - may or may not be necessary
  React.useEffect(() => {
    if (visible) {
      lottieRef.current?.goToAndPlay(0);
    } else {
      lottieRef.current?.stop();
    }
  }, [visible]);

  return (
    <div
      className="position--center z-max fixed h-screen w-screen flex items-center justify-center"
      style={{
        visibility: visible ? "visible" : "hidden",
        backgroundColor: palette.sheet,
      }}
    >
      <Lottie
        lottieRef={lottieRef}
        animationData={loadingAnimation}
        loop={true}
        autoplay={false}
        className={cn("z-10 w-[200px]", effectiveMode === "dark" && "invert")}
      />
    </div>
  );
}
